//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import {getNewsDetail,getNewsReadCount} from '@/api/qf';
export default {

  data() {
    return {
      newsId:'',
      newsInfo:{},
      modeType:'',
      srcList:[],
      htmlList:[],
      audioList:[],
      isShowVideo:false,
      countInfo:{},
      kh:0
    };
  },

  methods: {
    get_news_detail(){
      let params = {newsId:this.newsId}
      getNewsDetail(params).then((res) => {
        this.newsInfo = res.data;
        document.title = this.newsInfo.title;
        if(this.newsInfo.read > 10000){ //设置新闻详情阅读数
          this.num = this.newsInfo.read * 0.0001;
          this.num = this.num.toFixed(1);
          this.newsInfo.readNumber = this.num;
        }
        this.$nextTick(() => {
          $("video").attr("name","my_video");
          if(this.newsInfo.isEnglish){
            $("#body").css({"text-align": "left"});
          }else{
            $("#body").css({"text-align": "justify"});

          }
          //$("#body").css({"text-align": "left"});
          $("#yp-video").removeAttr("name");//这个是去除播放器的name属性 否则播放器也会被覆盖成图片
          this.srcList =document.getElementsByName("my_video");

          for(var i=0;i<this.srcList.length;i++){
            this.srcList[i].setAttribute("id",'video'+(i+1))
            var videoUrl = "";
            if(this.srcList[i].src == ''){
              var source = document.getElementById("video"+(i+1)).getElementsByTagName("source");
              videoUrl = source[0].getAttribute("src")
            }else{
              videoUrl = this.srcList[i].src
            }

            var html = "<div class='video-div' style='background-image: url("+this.srcList[i].poster+");'  id='my_name' data-video-url='"+videoUrl+"' data-isVideo='true'>"+
              "<div class='video-div-div' id='my_name'  data-video-poster='"+this.srcList[i].poster+"' data-video-url='"+videoUrl+"' data-isVideo='true'>"+
              "<div class='video-play' id='my_name'  data-video-poster='"+this.srcList[i].poster+"' data-video-url='"+videoUrl+"' data-isVideo='true'>"+
              "</div>"+
              "</div>"+
              "</div>";
            this.htmlList.push(html);
          }

          /****************************处理一图读懂************************/
          if($('.one-image').length > 0){
            var one_images = $('.one-image')[0].children;
            for(var z = 0;z <one_images.length;z++){
              if(one_images[z].tagName == 'IMG'){
                one_images[z].style.cssText = 'width: 100%;height: auto;display: block';
              }

            }
          }

          for(var j = 0;j<this.htmlList.length;j++){
            $('#video'+(j+1)).replaceWith(this.htmlList[j]);
          }
          /******************************测试音频*****************************/
          $("audio").attr("name","my_audio");
          var audios =document.getElementsByName("my_audio");
          $.each(audios, (b,val)=>{
            if(val.getAttribute("duration") != null){
              jQuery(val).attr('id','myAudio'+b);
              if (val != null) {
                var duration;
                val.load();
                var  audio = {
                  audioId:'myAudio'+b,
                  audioSrc:document.getElementById("myAudio"+b).getElementsByTagName("source")[0].getAttribute("src"),
                  duration:this.formatDuraton(val.getAttribute("duration"))
                }
                this.audioList.push(audio)
                var audioHtml = '<div style="background-color: #EEEEEE;max-width: 670px;  height: 2.875rem;  border: 1px solid #DDDDDD;  border-radius: 4px;  width: 92%;  margin: 0 auto;">'+
                  '<div style="float: left;  text-align: center;  width: 18%;  height: 100%;">'+
                  '<div style="width: 32px;height: 32px;background-color: #cd3333;border-radius: 4px;margin: 7px 0px 7px 9px;display: flex;justify-content: center;align-items: center;">'+
                  '<div style="width: 10px;height: 12px;background-repeat: round;background-image: url(../../assets/images/detail/play1.png)" id="audioPlayer'+b+'"></div>'+
                  '</div>'+
                  '</div>'+
                  '<div style="margin-right: 2%;  float: left;  width: 68%;  height: 100%;margin-left: 2%;">'+
                  '<div style="background-color: #dddddd;  position: relative;  height: 4px;  cursor: pointer;  margin-top: 0.8rem;  border-radius: 4px;" id="progressBarBg'+b+'">'+
                  '<span id="progressDot'+b+'" style="width: 12px;  height: 12px;  border-radius: 50%;  -moz-border-radius: 50%;  -webkit-border-radius: 50%;  background-color: #cd3333;  position: absolute;  left: 0;  top: 50%;  margin-top: -6px;  margin-left: -5px;  cursor: pointer;"></span>'+
                  '<div style="background-color: #cd3333;  width: 0;  height: 4px;" id="progressBar'+b+'"></div>'+
                  '</div>'+
                  '<div style="overflow: hidden;  margin-top: 10px;">'+
                  '<span style="float: left;  font-size: 10px;  color: #666666;line-height: 10px;" id="audioCurTime'+b+'">00:00</span>'+
                  '<span style="float: right;  font-size: 10px;  color: #666666;line-height: 10px;" id="durationTime'+b+'"></span>'+
                  '</div>'+
                  '</div>'+
                  '<div style="width: 4%;float: right;height: 100%;display:flex;justify-content:center;align-items:center;margin-right: 3.5%;"><div style="width: 11px;height: 14px;background-image: url(../../assets/images/detail/swing.png);background-repeat: round;" id="audioSurge'+b+'"></div></div>'+
                  '</div>'
                $('#myAudio'+b).after(audioHtml);
                $('#myAudio'+b).removeAttr("controls");
                sessionStorage.setItem('m'+b, 0);
                var audioDom = document.getElementById("myAudio"+b);
                this.initAudioEvent(audioDom,b,this.audioList);
              }
            }
          });
          /******************************测试音频*****************************/
        })
      })
    },
    getNewsReadCount(){
      let params = {newsId:this.newsId}
      getNewsReadCount(params).then((res) => {
        this.countInfo = res
      })
    },
    initAudioEvent(audioDom,index,audioList){
      var audioPlayer = document.getElementById('audioPlayer'+index);
      var audioSurge = document.getElementById('audioSurge'+index);
      document.getElementById('durationTime'+index).innerText = this.transTime(audioDom.getAttribute("duration"));
      // 点击播放/暂停图片时，控制音乐的播放与暂停
      audioPlayer.addEventListener('click',() =>{
        // 监听音频播放时间并更新进度条
        audioDom.addEventListener('timeupdate', () => {
          this.updateProgress(audioDom,index);
        }, false);

        // 监听播放完成事件
        audioDom.addEventListener('ended', () => {
          this.audioEnded(index);
        }, false);
        // 改变播放/暂停图片
        if (audioDom.paused) {
          // 开始播放当前点击的音频
          audioDom.play();
          audioPlayer.style.background="url('static/images/pause1.png')";
          audioPlayer.style.backgroundRepeat='round';
          audioSurge.style.background="url('static/images/surge.gif')";
          audioSurge.style.backgroundRepeat='round';
          for(var i=0;i<audioList.length;i++){
            if(audioDom.getAttribute("id") != audioList[i].audioId){
              var otherAudio = document.getElementById("myAudio"+i);
              var otherAudioPlayer = document.getElementById('audioPlayer'+i);
              var otherAudioSurge = document.getElementById('audioSurge'+i);
              otherAudio.pause();
              otherAudioPlayer.style.background="url('static/images/play1.png')";
              otherAudioPlayer.style.backgroundRepeat='round';
              otherAudioSurge.style.background="url('static/images/swing.png')";
              otherAudioSurge.style.backgroundRepeat='round';
            }
          }
        } else {
          audioDom.pause();
          audioPlayer.style.background="url('static/images/play1.png')";
          audioPlayer.style.backgroundRepeat='round';
          audioSurge.style.background="url('static/images/swing.png')";
          audioSurge.style.backgroundRepeat='round';
        }
      }, false);

      // 点击进度条跳到指定点播放
      // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处（简直不能忍！！）
      var progressBarBg = document.getElementById('progressBarBg'+index);
      progressBarBg.addEventListener('mousedown', (event) => {
        // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
        if (!audioDom.paused || audioDom.currentTime != 0) {
          var pgsWidth = parseFloat(window.getComputedStyle(progressBarBg, null).width.replace('px', ''));
          var rate = event.offsetX / pgsWidth;
          audioDom.currentTime = audioDom.duration * rate;
          this.updateProgress(audioDom,index);
        }
      }, false);

      // 拖动进度点调节进度
      this.dragProgressDotEvent(audioDom,index);
    },
    updateProgress(audio,index){
      var value = audio.currentTime / audio.duration;
      document.getElementById('progressBar'+index).style.width = value * 100 + '%';
      document.getElementById('progressDot'+index).style.left = value * 100 + '%';
      document.getElementById('audioCurTime'+index).innerText = this.transTime(audio.currentTime);
    },
    audioEnded(index){
      document.getElementById('progressBar'+index).style.width = 0;
      document.getElementById('progressDot'+index).style.left = 0;
      document.getElementById('audioCurTime'+index).innerText = this.transTime(0);
      document.getElementById('audioPlayer'+index).style.background="url('static/images/play1.png')";
      document.getElementById('audioPlayer'+index).style.backgroundRepeat='round';
    },
    transTime(value){
      var time = "";
      var h = parseInt(value / 3600);
      value %= 3600;
      var m = parseInt(value / 60);
      var s = parseInt(value % 60);
      if (h > 0) {
        time = this.formatTime(h + ":" + m + ":" + s);
      } else {
        time = this.formatTime(m + ":" + s);
      }

      return time;
    },
    formatTime(value){
      var time = "";
      var s = value.split(':');
      var i = 0;
      for (; i < s.length - 1; i++) {
        time += s[i].length == 1 ? ("0" + s[i]) : s[i];
        time += ":";
      }
      time += s[i].length == 1 ? ("0" + s[i]) : s[i];

      return time;
    },
    dragProgressDotEvent(audio,index){
      var dot = document.getElementById('progressDot'+index);
      var progressBarBg = document.getElementById('progressBarBg'+index);

      var position = {
        oriOffestLeft: 0, // 移动开始时进度条的点距离进度条的偏移值
        oriX: 0, // 移动开始时的x坐标
        maxLeft: 0, // 向左最大可拖动距离
        maxRight: 0 // 向右最大可拖动距离
      };
      this.flag = false; // 标记是否拖动开始
      dot.ontouchstart = ((e) =>{
        if (!audio.paused || audio.currentTime != 0) { // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
          this.flag = true;

          position.oriOffestLeft = dot.offsetLeft;
          position.oriX = event.touches ? event.touches[0].clientX : event.clientX; // 要同时适配mousedown和touchstart事件
          position.maxLeft = position.oriOffestLeft; // 向左最大可拖动距离
          position.maxRight = document.getElementById('progressBarBg'+index).offsetWidth - position.oriOffestLeft; // 向右最大可拖动距离

          // 禁止默认事件（避免鼠标拖拽进度点的时候选中文字）
          if (event && event.preventDefault) {
            event.preventDefault();
          } else {
            event.returnValue = false;
          }

          // 禁止事件冒泡
          if (event && event.stopPropagation) {
            event.stopPropagation();
          } else {
            window.event.cancelBubble = true;
          }
        }

        progressBarBg.ontouchmove = (e)=> {
          if (this.flag) {
            var clientX = event.touches ? event.touches[0].clientX : event.clientX; // 要同时适配mousemove和touchmove事件
            var length = clientX - position.oriX;
            if (length > position.maxRight) {
              length = position.maxRight;
            } else if (length < -position.maxLeft) {
              length = -position.maxLeft;
            }
            var progressBarBg = document.getElementById('progressBarBg'+index);
            var pgsWidth = parseFloat(window.getComputedStyle(progressBarBg, null).width.replace('px', ''));
            var rate = (position.oriOffestLeft + length) / pgsWidth;
            audio.currentTime = audio.duration * rate;
            this.$options.methods.updateProgress(audio,index);
          }
        }

        progressBarBg.ontouchend = (e)=> {
          this.flag = false;
        }
      })
    },
    onPlay(a,n){
        this.isShowVideo = true
    },
    openImageProxy: function (event) {
      if (event.target.id === 'my_name') {
        this.videoUrl = event.target.getAttribute("data-video-url");
        this.imgUrl = event.target.getAttribute("data-video-poster");
        this.isShowVideo = true;
        $("video").attr("src",this.videoUrl);
        $("#closeVideo").show();
        //$('video').trigger('play');
      }

    },
    closeVideo(){
      $('video').trigger('pause');
      $("video").attr("src","")
      this.isShowVideo = false;
      $("#closeVideo").hide();
    },
  },
  mounted () {
    this.newsId = this.$route.query.newsId;
    this.kh = this.$route.query.kh;
    console.log(this.kh)
    this.get_news_detail();
    this.getNewsReadCount();
    $("#closeVideo").hide();
  },
};





// WEBPACK FOOTER //
// ./src/pages/qf/news_detail.vue